import React from "react";
import { useContent } from "../../content/ContentContext";

export const WhyWorkWithMe = () => {
  const c = useContent("why");
  return (
    <section data-testid="why-section" className="relative overflow-hidden">
      <div className="text-white sc-section relative" style={{ backgroundColor: "#1c1418" }}>
        <div
          aria-hidden="true"
          className="absolute inset-0 opacity-[0.16] pointer-events-none"
          style={{
            background:
              "radial-gradient(55% 60% at 18% 25%, #B42B6A 0%, transparent 65%), radial-gradient(45% 55% at 85% 75%, #B89456 0%, transparent 65%)",
          }}
        />
        <div className="sc-container relative text-center max-w-3xl">
          <span className="sc-eyebrow text-gold">{c.eyebrow}</span>
          <h2 className="sc-h2 mt-4 text-[#FAF5F6]" data-testid="why-heading">
            {c.heading_pre}{" "}
            <em className="not-italic">{c.heading_em}</em>
          </h2>
          <p className="mt-6 text-[17px] md:text-[19px] leading-[1.8] text-white/85 font-body">
            {c.body}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyWorkWithMe;
